import { DeviceMode } from './deviceMode';

export const DEVICE_SIZES = {
    [DeviceMode.Mobile]: [390, 844],
    [DeviceMode.Tablet]: [768, 1024],
    [DeviceMode.Desktop]: [1024, 768],
    [DeviceMode.All]: [1024 + 768 + 390 + 60, 1024],
};